import React, { useState, useEffect } from 'react'
import { BlobDocumentApi, ProjectDocumentApi } from '../../../common/services'

interface renderImageCheckTypeProps {
  id: number
  type: string
}

const renderImageCheckType = ({ id, type }: renderImageCheckTypeProps): JSX.Element => {
  console.log(type)
  const [imageUrl, setImageUrl] = useState<string | null>(null)
  useEffect(() => {
    void fetchImage(id ?? 0)
  }, [id])

  const fetchImage = async (id: number): Promise<void> => {
    try {
      if (type === 'project') {
        const response = await new ProjectDocumentApi().apiV2ProjectDocumentDownloadGet(
          id,
          { responseType: 'blob' } // đảm bảo API trả về blob
        ) as any
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const url = window.URL.createObjectURL(blob)
        setImageUrl(url)
      } else {
        const response = await new BlobDocumentApi().apiV2BlobDocumentDownloadBlobDocumentGet(
          id,
          { responseType: 'blob' } // đảm bảo API trả về blob
        ) as any
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const url = window.URL.createObjectURL(blob)
        setImageUrl(url)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  return (imageUrl != null)
    ? (
    <img
      width={50}
      height={30}
      style={{ objectFit: 'contain', cursor: 'pointer' }}
      src={imageUrl}
      alt={'image'}
    />
      )
    : (
    <div style={{ width: 50, height: 30, backgroundColor: '#f0f0f0' }} />
      )
}

export default renderImageCheckType
